module.exports = __webpack_public_path__ + "img/icon_sportMenu_football.6df27b21.svg";